import {Dialog} from 'platform/components';
import {Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {DEFAULT_DECISION_DAYS} from '../../model/auctionView';

interface EndAuctionDialogProps {
  isOpen: boolean;
  roundNumber: number | null;
  onClose: () => void;
  onEnd: () => void;
}

export function EndAuctionDialog(props: EndAuctionDialogProps) {
  return (
    <Dialog
      isOpen={props.isOpen}
      size="small"
      title={i18n.t('entity.auction.endAuction.title')}
      onClose={props.onClose}
      buttons={[
        {
          title: i18n.t('entity.auction.endAuction.keepOpen'),
          variant: 'secondary',
          onClick: props.onClose,
        },
        {
          title: i18n.t('entity.auction.header.endAuction'),
          variant: 'danger',
          onClick: () => {
            props.onEnd();
            props.onClose();
          },
          'data-testid': 'auction-end-confirm',
        },
      ]}
      data-testid="auction-end-dialog"
    >
      <VStack spacing={2}>
        <Text alternative>
          {i18n.t('entity.auction.endAuction.text', {round: props.roundNumber ?? 1})}
        </Text>
        <Text color="secondary">
          {i18n.t('entity.auction.endAuction.note', {days: DEFAULT_DECISION_DAYS})}
        </Text>
      </VStack>
    </Dialog>
  );
}
